import { useState } from "react";
import "./Search.css";

const SearchIconSvg = (props) => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M11 19C15.4183 19 19 15.4183 19 11C19 6.58172 15.4183 3 11 3C6.58172 3 3 6.58172 3 11C3 15.4183 6.58172 19 11 19Z"
      stroke="#9CA3AF"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M21 21L16.65 16.65"
      stroke="#9CA3AF"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const FilterIconSvg = (props) => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M6 12H18M3 6H21M9 18H15"
      stroke="#9CA3AF"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);


export default function SearchInput({
  placeholder = "Procure...",
  className,
  onSearchChange,
  onFilterClick,
}) {
  const [inputValue, setInputValue] = useState("");

  const handleInputChange = (e) => {
    const newValue = e.target.value;
    setInputValue(newValue);
    if (onSearchChange) {
      onSearchChange(newValue);
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (onSearchChange) {
      onSearchChange(inputValue);
    }
  };

  return (
    <form onSubmit={handleSubmit} className={`search-form ${className || ""}`}>
      <div className="search-container">
        <SearchIconSvg className="search-icon" />

        <input
          type="text"
          value={inputValue}
          onChange={handleInputChange}
          placeholder={placeholder}
          className="search-input"
        />

        {onFilterClick && (
          <button type="button" onClick={onFilterClick} className="filter-button">
            <FilterIconSvg className="filter-icon" />
          </button>
        )}
      </div>
    </form>
  );
}